import { CardBlock, Icon } from '@coast/schemas';
import { isNil, isNull } from 'lodash';
import { isInputComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';

export function correctMissingBlockData(
  blocks?: CardBlock[],
  components?: API.AnyComponent[],
): CardBlock[] {
  return (
    blocks?.map(block => {
      if (!('name' in block)) {
        return block;
      }
      const component = components?.find(c => c.id === block.name);
      if (isNil(component) || !isInputComponent(component)) {
        return block;
      }
      const newBlock = {
        ...block,
      };
      if ('icon' in newBlock && isNull(newBlock.icon)) {
        newBlock.icon = component.icon as Icon;
      }
      if ('label' in newBlock && isNull(newBlock.label)) {
        newBlock.label = component.label ?? '';
      }
      if ('placeholder' in newBlock && isNull(newBlock.placeholder)) {
        newBlock.placeholder = component.placeholder ?? '';
      }
      if ('tableHeader' in newBlock && isNull(newBlock.tableHeader)) {
        newBlock.tableHeader = component.label ?? '';
      }
      return newBlock;
    }) ?? []
  );
}
